export default __webpack_public_path__ + "static/media/Contato.8247314b.png";